var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lexicon-input"}},[_c('textarea',{staticClass:"lexicon-input",attrs:{"type":"text","placeholder":"Enter additional words to search through"},domProps:{"value":_vm.customLexicon},on:{"input":_vm.handleInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }